module.exports = _.extend({
  initialize: function () {
    const tool = INKIVE.Tool.getInstance();
    this.canvas = tool.editor.canvas;
  },

  ungroup: function (element) {
    const data = INKIVE.DesignFacade.get(element.id);
    const elements = (data.type === 'group' ? data.elements : [data])
      .map(element => element.id);

    this.canvas.selectOnly([element]);
    this.canvas.ungroupSelectedElement();

    this.trigger('ungroup', element.id, { elements });
  }
}, Backbone.Events);
